var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dd',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"zm-select-group__wrap",attrs:{"role":"group","aria-label":_vm.label}},[_c('dl',{attrs:{"role":"listbox"}},[_c('dt',{staticClass:"zm-select-group__title"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }